import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=b612c7f4&scoped=true&"
import script from "./order_detail.vue?vue&type=script&lang=js&"
export * from "./order_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=b612c7f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b612c7f4",
  null
  
)

export default component.exports